import styled from '@emotion/styled';

import { keyframes } from '@emotion/react';

export type LoaderProps = {
  size?: 'small' | 'medium' | 'large';
};

const spinning = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderWrapper = styled.div<{ size: string }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${({ size }) => size};
  height: ${({ size }) => size};

  > div:nth-of-type(1) {
    animation-delay: -0.45s;
  }
  > div:nth-of-type(2) {
    animation-delay: -0.3s;
  }
  > div:nth-of-type(3) {
    animation-delay: -0.15s;
  }
`;

const CircleElement = styled.div<{ size: string; borderSize: string }>`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  margin: 8px;
  border: ${({ borderSize }) => borderSize} solid var(--color-blue-500);
  border-radius: 50%;
  animation: ${spinning} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: var(--color-blue-500) transparent transparent transparent;
`;

export const Loader = ({ size = 'medium' }: LoaderProps) => {
  const wrapperSizeMap = {
    small: '18px',
    medium: '32px',
    large: '48px',
  };

  const borderSizeMap = {
    small: '2px',
    medium: '3px',
    large: '4px',
  };

  const circleSizeMap = {
    small: '18px',
    medium: '24px',
    large: '36px',
  };

  return (
    <LoaderWrapper size={wrapperSizeMap[size]}>
      <CircleElement
        size={circleSizeMap[size]}
        borderSize={borderSizeMap[size]}
      />
      <CircleElement
        size={circleSizeMap[size]}
        borderSize={borderSizeMap[size]}
      />
      <CircleElement
        size={circleSizeMap[size]}
        borderSize={borderSizeMap[size]}
      />
      <CircleElement
        size={circleSizeMap[size]}
        borderSize={borderSizeMap[size]}
      />
    </LoaderWrapper>
  );
};
